import type { OfferContextEvent } from 'analytics/snowplow/context'
import { createContext } from 'react'

export interface OfferPageStateTracking {
  trackEvent: (event: OfferContextEvent) => void
}

function defaultTrackEvent(event: string) {
  console.warn(`Tracking for ${event} is not implemented`)
}

const OfferPageStateTrackingContext = createContext<OfferPageStateTracking>({ trackEvent: defaultTrackEvent })

export default OfferPageStateTrackingContext
